import Api from "~/service/Api";

class Immersive3dTourFloorPlanUpdateRequestRepository {
  update(tourId) {
    return Api.post(`/immersive-3d-tour/floor-plan/update-requests/${tourId}`);
  }
}

export default Immersive3dTourFloorPlanUpdateRequestRepository;
